import boletines from '../../../../assets/data/boletines'
import './boletines-timeline.css'

const DownloadIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='15'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <polyline points='7 10 12 15 17 10' />
    <line x1='12' y1='15' x2='12' y2='3' />
  </svg>
)

const groupByYear = (items) =>
  items.reduce((acc, item) => {
    if (!acc[item.year]) acc[item.year] = []
    acc[item.year].push(item)
    return acc
  }, {})

const COLLAPSED_YEARS = new Set(['2025', '2024'])

const BoletinesTimeline = () => {
  const grouped = groupByYear(boletines)
  const years = Object.keys(grouped).sort((a, b) => b - a)

  const renderItems = (yearItems, year) =>
    yearItems.map((item, idx) => (
      <div key={idx} className='boletines-timeline__item' role='listitem'>
        <span className='boletines-timeline__item-dot' aria-hidden='true' />
        <span className='boletines-timeline__item-date'>{item.label}</span>
        <a
          className='boletines-timeline__download'
          href={item.file}
          download
          target='_blank'
          rel='noreferrer'
          aria-label={`Descargar boletín del ${item.label} de ${year}`}
        >
          <DownloadIcon />
          <span className='boletines-timeline__download-text'>PDF</span>
        </a>
      </div>
    ))

  return (
    <section className='boletines-timeline' aria-labelledby='boletines-heading'>
      <div className='boletines-timeline__inner'>
        {/* Left: heading */}
        <div className='boletines-timeline__header'>
          <p className='boletines-timeline__eyebrow'>Actualidad</p>
          <h2 className='boletines-timeline__title' id='boletines-heading'>
            Boletines
          </h2>
          <div className='boletines-timeline__divider' aria-hidden='true' />
          <p className='boletines-timeline__desc'>
            Consulta y descarga nuestros boletines periódicos, con noticias,
            actividades y reflexiones sobre cultura menstrual.
          </p>
        </div>

        {/* Right: vertical timeline */}
        <div className='boletines-timeline__list' role='list'>
          <div className='boletines-timeline__line' aria-hidden='true' />
          {years.map((year) => (
            <div key={year} className='boletines-timeline__year-group' role='listitem'>
              <div className='boletines-timeline__year-marker' aria-hidden='true'>
                <span className='boletines-timeline__year-dot' />
              </div>

              {COLLAPSED_YEARS.has(year) ? (
                <details className='boletines-timeline__year-accordion'>
                  <summary className='boletines-timeline__year-summary'>
                    <span className='boletines-timeline__year-label'>{year}</span>
                  </summary>
                  <div className='boletines-timeline__year-items' role='list'>
                    {renderItems(grouped[year], year)}
                  </div>
                </details>
              ) : (
                <>
                  <span className='boletines-timeline__year-label'>{year}</span>
                  {renderItems(grouped[year], year)}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BoletinesTimeline
